import React from 'react'
import { Form, Input } from 'antd'
import { Controller } from 'react-hook-form'

const { TextArea } = Input

export interface TextAreaProps {
  fieldname: string
  isRequired?: boolean
  label?: string
  validate?: any
  validMessage?: string
  className?: string
  control: any
  initValue?: any
  rules?: any
  iProps?: any
  prefix?: any
}

const TextAreaField: React.FunctionComponent<TextAreaProps> = ({
  fieldname,
  isRequired,
  label,
  validate,
  validMessage,
  className,
  control,
  initValue,
  rules,
  iProps,
  prefix,
}: TextAreaProps) => {
  return (
    <Form.Item
      required={isRequired ?? false}
      validateStatus={validate}
      help={validMessage}
      label={label}
      valuePropName="checked"
      className={className}
    >
      <Controller
        rules={rules}
        name={fieldname}
        control={control}
        defaultValue={initValue ?? ''}
        render={({ field: { onChange, value } }) => (
          <>
            <div className="select_prefix">{prefix}</div>
            <TextArea
              value={value}
              className="formControl"
              onChange={(e) => {
                onChange(e)
              }}
              {...iProps}
            />
          </>
        )}
      />
    </Form.Item>
  )
}

export default TextAreaField
